import { DSToggle } from "@components/design-system/molecules";
import {
  faMicrophone,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import mixpanel from "mixpanel-browser";
import React, { useState } from "react";

import { usePremiumFeature } from "../../../hooks/use-premium-feature";
import { useTwilioAPI } from "../../../hooks/use-twilio-api";
import UpgradeModal from "../premium/UpgradeModal";

export default function CallRecordingToggle() {
  const { isRecordingScribephoneMode, updateRecordingMode } =
    useTwilioAPI();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const { UserPermissions, hasFeatureAccess } = usePremiumFeature();

  const isCall = isRecordingScribephoneMode;

  const hasScribephoneAccess = hasFeatureAccess(
    UserPermissions.SCRIBEPHONE_ENABLED,
  );

  const handleToggle = (newValue) => {
    mixpanel.track("Scribephone toggle clicked", {
      previousMode: isCall ? "phone" : "microphone",
      newMode: newValue ? "phone" : "microphone",
      hasAccess: hasScribephoneAccess,
    });
    if (newValue && !hasScribephoneAccess) {
      setShowUpgradeModal(true);
      return;
    }
    updateRecordingMode(newValue);
  };

  return (
    <div className="flex justify-center w-full ml-[2px]">
      <UpgradeModal
        shouldShow={showUpgradeModal}
        setShouldShow={setShowUpgradeModal}
        featureName="Scribephone"
      />
      <div className="flex flex-row items-center space-x-2 mx-2">
        <FontAwesomeIcon
          icon={faMicrophone}
          className={` ${hasScribephoneAccess && "cursor-pointer"}`}
          size="1x"
          onClick={() => {
            if (hasScribephoneAccess && isCall) {
              handleToggle(false);
            }
          }}
        />
        <DSToggle
          checked={!hasScribephoneAccess ? false : isCall}
          onChange={(e) => handleToggle(e.target.checked)}
          dataTestId="scribephone-toggle-switch"
        />
        <FontAwesomeIcon
          icon={faPhone}
          className={` ${hasScribephoneAccess && "cursor-pointer"}`}
          size="1x"
          onClick={() => {
            if (hasScribephoneAccess && !isCall) {
              handleToggle(true);
            }
          }}
        />
      </div>
    </div>
  );
}
